export const API_URL = process.env.REACT_APP_API_URL || 'https://rein.platform.co.nl';
export const SITE_URL =
  process.env.REACT_APP_SITE_URL || 'https://rein.platform.co.nl';

export const API_SCHEMA_URL = `${API_URL}/api/schema/`;
export const SCORM_DOMAIN = process.env.REACT_APP_SCORM_DOMAIN;
export const LXP_URL = process.env.REACT_APP_LXP_URL || 'http://reinprikbord.qa.platform.co.nl';
